var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('simple-page',{attrs:{"title":_vm.title,"sections":_vm.sections}}),_c('card-navigation',{attrs:{"cards":_vm.cards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }